import React, { useEffect, useRef, useState } from "react";
import GenerateURL from "../../../utils/ApiUrlProvider";
import properties from "../../../Properties/Properties";
import { renderInput } from "../../Common/FormComponents";
import { PutData } from "../../../utils/ApiInvoker";
import { useParams } from "react-router-dom";

const RMEditModal = ({ onClose, initialRMData }) => {
  const [formData, setFormData] = useState({
    name: initialRMData.name || "",
    mobile_number: initialRMData.mobile_number || "",
    email: initialRMData.email || "",
  });
  const params = useParams();
  const [formErrors, setFormErrors] = useState({
    name: "",
    mobile_number: "",
    email: "",
  });

  const modalRef = useRef();

  const [preloading, setPreloading] = useState(false);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };

  const handleInteractionInsideModal = (event) => {
    event.stopPropagation();
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleSaveClick = () => {
    setPreloading(true);
    updateUserInfo();
  };

  const validateForm = () => {
    let valid = true;
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = "Name is required";
      valid = false;
    }

    const mobileRegex = /^[0-9]{10}$/;
    if (
      !formData.mobile_number.trim() ||
      !mobileRegex.test(formData.mobile_number.trim())
    ) {
      errors.mobile_number = "Invalid mobile number (should be 10 digits)";
      valid = false;
    }

    if (!formData.email.trim()) {
      errors.email = "Email is Required";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email.trim())) {
      errors.email = "Invalid Email Adress type";
      valid = false;
    }

    setFormErrors(errors);
    return { valid, errors };
  };

  function saveResposneSucess(response) {
    setPreloading(false);
    console.log(response);
    window.location.reload();
  }

  function saveResposneFailure(response) {
    setPreloading(false);
    console.log(response);
    const error = {
      mobile_number: response.mobile_number ? response.mobile_number[0] : "",
      email: response.email ? response.email[0] : "",
    };
    setFormErrors(error);
  }

  function updateUserInfo(e) {
    const validation = validateForm();

    if (validation.valid) {
      var url = GenerateURL({ id: params.id }, properties.api.adminSingleRM);

      PutData(url, formData, saveResposneSucess, saveResposneFailure, false);
    } else {
      setFormErrors(validation.errors);
    }
  }

  const handlechange = (e) => {
    const { name, value } = e.target;
    let inputNumeric;
    if (name === "mobile_number") {
      inputNumeric = /^[0-9\b]+$/;
      if (value === "" || inputNumeric.test(value)) {
        setFormErrors({ ...formErrors, [name]: "" });
        setFormData({ ...formData, [name]: value });
      } else {
        setFormErrors({
          ...formErrors,
          [name]: "Please enter only numeric values.",
        });
      }
    } else if (name === "name") {
      let inputAlphabets = /^[A-Za-z]+$/;
      if (value === "" || inputAlphabets.test(value)) {
        setFormErrors({ ...formErrors, [name]: "" });
        setFormData({ ...formData, [name]: value });
      } else {
        setFormErrors({
          ...formErrors,
          [name]: "Please enter only alphabetic values.",
        });
      }
    } else {
      setFormData({ ...formData, [name]: value });
      setFormErrors({ ...formErrors, [name]: "" });
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60"
      onClick={onClose}
    >
      <div
        className="w-[80%] sm:w-[55%] md:1/2  sm:ml-60 p-6 bg-white rounded-lg shadow-lg mt-48 mb-80 lg:w-1/2  "
        onClick={handleInteractionInsideModal}
        ref={modalRef}
      >
        <div className="flex justify-between border-b-2 pb-4 text-2xl md:text-3xl  font-bold text-gray-800 mb-4 md:mb-6">
          <h1 className="font-medium text-xl ">Edit Information</h1>
          <div className="flex flex-row relative">
            <button className="rounded-lg px-1  hover:scale-110">
              <img
                src="https://cdn-icons-png.flaticon.com/128/2997/2997911.png"
                alt=""
                className="h-5"
                onClick={onClose}
              />
            </button>
          </div>
        </div>
        <div className="p-8 gap-5 flex flex-col items-center justify-center">
          <>
            <div className="w-full flex flex-col">
              {renderInput("STRING", {
                label: "Name",
                name: "name",
                value: formData.name,
                onChange: handlechange,
                error: formErrors.name,
                tooltip: "Use letters only for the name",
              })}
              {renderInput("STRING", {
                label: "Mobile Name",
                name: "mobile_number",
                value: formData.mobile_number,
                onChange: handlechange,
                error: formErrors.mobile_number,
                tooltip: "Only 10 Digit Number",
              })}
              {renderInput("STRING", {
                label: "Email",
                name: "email",
                value: formData.email,
                onChange: handlechange,
                error: formErrors.email,
                tooltip: `Use "@" , ".com"`,
              })}
              <div className="flex justify-center items-center">
                <button
                  className="bg-blue-500 text-white px-1 py-1 md:px-4 md:py-2   rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-300  "
                  onClick={handleSaveClick}
                >
                  Save
                </button>
              </div>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default RMEditModal;
